export const SERVICE_TYPES_TEST_IDS = {
  orderTypeDropDownBtn: 'order-type',
};
